import Vue from "vue";
import VueRouter from "vue-router";
import AdminLayout from "../layouts/AdminLayout.vue";
import { setCode } from '@/utils/codeContext'
import store from '@/store'  // 导入store

Vue.use(VueRouter);

const routes = [
  {
    path: "/login",
    name: "login",
    component: () => import("../views/login.vue"),
  },
  {
      path: "/home/:channelCode",
      name: "home",
      component: () => import("../views/home/home.vue"),
  },
  {
    path: "/auto/:channelCode",
    name: "auto",
    component: () => import("../views/auto.vue"),
  },
  {
    path: "/401",
    name: "401",
    component: () => import("../views/401.vue"),
  },
  {
    path: "/405",
    name: "405",
    component: () => import("../views/405.vue"),
  },
  {
    path: '/',
    component: AdminLayout,
    redirect: `/home/${store.state.channel.channelCode}`,
    children:[
      {
        path: "/ai",
        name: "ai",
        component: () => import("../views/ai/ai.vue"),
      },
      // 维盾智库列表页
      {
        path: "/tankList",
        name: "tankList",
        component: () => import("../views/thinkTank/List.vue"),
      },
      // 维盾智库问答页
      {
        path: "/tank",
        name: "tank",
        component: () => import("../views/thinkTank/index.vue"),
      },
      // 历史记录
      {
        path: "/history",
        name: "history",
        component: () => import("../views/history/List.vue"),
      },
      {
        path: "/setting",
        name: "setting",
        component: () => import("../views/setting/setting.vue"),
      },
    {
        path: "/knowledge",
        name: "knowledge",
        component: () => import("../views/knowledge/index.vue"),
    },
      //法律法规
      {
        path: "/knowledge/law",
        name: "law",
        meta: {
          keepAlive: true,
        },
        component: () => import("../views/knowledge/law/index.vue"),
      },
      {
        path: "/knowledge/details",
        name: "details",
        meta: {
          keepAlive: true,
        },
        component: () => import("../views/knowledge/law/details.vue"),
      },
      //  典型案例
      {
        path: "/knowledge/typicalCases",
        name: "typicalCases",
        meta: {
          keepAlive: true,
        },
        component: () => import("../views/knowledge/typicalCases/index.vue"),
      },
      {
        path: "/knowledge/typicalCases/details",
        name: "typicalCasesDetails",
        meta: {
          keepAlive: true,
        },
        component: () => import("../views/knowledge/typicalCases/details.vue"),
      },
      // 收藏
      {
          path: "/knowledge/collect",
          name: "collect",
          component: () => import("../views/knowledge/collect/index.vue"),
      },
    ]
  },
  {
    path: "/404",
    name: "404",
    component: () => import("../views/404.vue"),
  },
  {
    path: "*",
    redirect: '/404',
  }
];

const router = new VueRouter({
  // mode: 'history',
  routes,
});

// 全局前置守卫：切换路由前，门卫先检查
router.beforeEach((to, from, next) => {
  if (to.params.channelCode) {
    setCode(to.params.channelCode)
  }

  let { state } = store
  
  // 当前渠道没有配置智能体
  // 白名单路由
  let whiteList = ['home','auto','401','405','setting','knowledge','law','details','typicalCases','typicalCasesDetails','collect','login']
  if(!state.agent.defaultConfig.agentId && !whiteList.includes(to.name)){
    next('/405')
    return;
  }

  // 如果渠道已停用
  if(state.channel.isStop && !whiteList.includes(to.name)){
    next('/401')
    return;
  }

  // 没有渠道号
  if(!state.channel.channelCode && to.name != 'home' && to.name != 'auto' && to.name != '401' && to.name != '405'){
    next('/401')
    return;
  }

  // 不需要登录
  if(!state.channel.isLogin){
    next() // 放行
  }else{
    let token = localStorage.getItem("web_login_token");
    let nextRouter = ['/405','/auto','/401','/test','/','/login','/home','/knowledge','/knowledge/law','/knowledge/details','/knowledge/typicalCases','/knowledge/typicalCases/details']

    if(to.name == 'home'){
      next() // 放行
      return
    }

    if(nextRouter.indexOf(to.path) == -1 && !token){
      next(`/login?redirect=${to.fullPath}`)
    }else{
      next() // 放行
    }
  }

})

const VueRouterPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch((err) => err);
};
const VueRouterReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function replace(to) {
  return VueRouterReplace.call(this, to).catch((err) => err);
};
export default router;
